import {
  Box,
  Button,
  Grid,
  TextField,
  MenuItem,
  IconButton,
  FormControl,
  InputLabel,
  Select,
} from '@mui/material';
import { useForm, useFieldArray } from 'react-hook-form';
import { useEffect, useState } from 'react';
import { url } from 'src/Helpers/utils/Constant';
import { HttpClient } from 'src/Helpers/http/http';
import { LoadingButton } from '@mui/lab';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import moment from 'moment';
import { IAccountType } from '../Members/MemberAccount/Account/types/AccountTypes';
import SelectOtherHeadList from './SelectOtherHeadList';
import PostDataApis from 'src/common/FetchData/PostDataApis';

const CreateOtherIncome = ({ handelClose }: any) => {
  const { register, handleSubmit, control, watch, reset } = useForm();
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'items',
  });

  const [accountData, setAccountData] = useState<IAccountType[]>([]);
  const paymentMethod = watch('method');

  if (fields.length === 0) {
    append({ id: '', amount: '' });
  }

  const { postData, loading, success } = PostDataApis(`${url}/api/atab/income`);

  useEffect(() => {
    (async function () {
      try {
        HttpClient.get(`${url}/api/atab/common-account?CompanyProfileId=1`)
          .then(function (res: any) {
            if (res.success) {
              setAccountData(res.data);
            } else {
            }
          })
          .catch(function (err) {
            setAccountData([]);
          });
      } catch (error) {}
    })();
  }, []);

  const onSubmit = async (inputs: any) => {
    const submitData = { CompanyProfileId: 1, ...inputs };

    await postData(submitData);
  };

  useEffect(() => {
    if (success) {
      reset();
      handelClose();
    }
  }, [success]);
  return (
    <Box>
      <Box
        component='form'
        onSubmit={handleSubmit(onSubmit)}
        sx={{ padding: '0 15px' }}
      >
        <Grid container>
          <Grid item xs={12}>
            {fields?.map((item, index) => (
              <Grid
                container
                spacing={1}
                key={item.id}
                alignItems='center'
                sx={{
                  marginBottom: '10px',
                }}
              >
                <Grid item xs={12} sm={6} md={6}>
                  <SelectOtherHeadList
                    label='Other Head List'
                    control={control}
                    name={`items.${index}.id`}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <TextField
                    fullWidth
                    required
                    label='Amount'
                    type='number'
                    variant='outlined'
                    {...register(`items.${index}.amount`)}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={2} display={'flex'} columnGap={1}>
                  {fields.length > 1 && (
                    <Grid item xs='auto'>
                      <IconButton
                        onClick={() => remove(index)}
                        color='error'
                        sx={{ backgroundColor: 'rgba(255, 25, 67, 0.1)' }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Grid>
                  )}
                  {index === 0 && (
                    <Grid item xs='auto'>
                      <IconButton
                        onClick={() => append({ id: '', amount: '' })}
                        color='primary'
                        sx={{ backgroundColor: 'rgba(12, 77, 162, 0.1)' }}
                      >
                        <AddIcon />
                      </IconButton>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            ))}
          </Grid>

          {/* Additional Form Fields */}
          <Grid item xs={12} sx={{ marginTop: 2 }}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  required
                  id='income_date'
                  label='Income Date'
                  type='date'
                  InputLabelProps={{ shrink: true }}
                  variant='outlined'
                  {...register('income_date')}
                  defaultValue={moment().format('YYYY-MM-DD')}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  select
                  required
                  id='method'
                  label='Payment Method'
                  variant='outlined'
                  {...register('method')}
                >
                  {['Mobile Banking', 'Cash', 'Bank'].map((method) => (
                    <MenuItem key={method} value={method}>
                      {method}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth required>
                  <InputLabel id='account-select-label'>Account</InputLabel>
                  <Select
                    labelId='account-select-label'
                    id='account-select'
                    {...register('account_id')}
                    label='Account'
                  >
                    {accountData?.map((account) => (
                      <MenuItem key={account.id} value={account.id}>
                        {account.account_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {paymentMethod === 'Bank' && (
                <>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      required
                      id='bank_name'
                      label='Bank Name'
                      type='text'
                      variant='outlined'
                      {...register('bank_name')}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      required
                      id='cheque_no'
                      label='Cheque Number'
                      type='text'
                      variant='outlined'
                      {...register('cheque_no')}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      id='cheque_date'
                      label='Cheque Date'
                      type='date'
                      required
                      InputLabelProps={{ shrink: true }}
                      variant='outlined'
                      {...register('cheque_date')}
                    />
                  </Grid>
                </>
              )}

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label='Note'
                  type='text'
                  variant='outlined'
                  multiline
                  rows={4}
                  {...register('note')}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sx={{ marginTop: 2 }}>
            <Box textAlign='center'>
              {loading ? (
                <LoadingButton
                  loading={loading}
                  fullWidth
                  color='secondary'
                  disableElevation
                  variant='contained'
                >
                  Loading...
                </LoadingButton>
              ) : (
                <Button type='submit' variant='contained' disableElevation>
                  Create
                </Button>
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default CreateOtherIncome;
